<template>
  <TsCard
    id="trustpilot-review"
    data-testid="trustpilot-review"
    no-shadow
    append-class="flex justify-between gap-4 p-8"
  >
    <div class="flex w-full items-center justify-between gap-4">
      <div class="flex-1">
        <TsTrustpilot width="100%" height="40%" template-id="5613c9cde69ddc09340c6beb" />
      </div>

      <div class="flex-1 max-w-sm">
        <TsTypography
          as="h3"
          append-class="w-full font-semibold mb-2"
        >
          {{ useTranslation('rateRecentExp', 'Beoordeel uw recente ervaring') }}
        </TsTypography>

        <TsButton
          :link="WriteReviewLink"
          :label="useTranslation('writeAReview', 'Schrijf een recensie')"
          variant="success"
          linkTarget="_blank"
          outlined
          block
        />
      </div>
    </div>
  </TsCard>
</template>

<script setup lang="ts">
const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsTrustpilot = defineAsyncComponent(
    () => import('~/components/organisms/TsTrustpilot.vue')
);

const appRegion = useRuntimeConfig().public.appRegion;

const WriteReviewLink = appRegion === 'BE' ? 'https://www.trustpilot.com/review/toolstation.be' : 'https://www.trustpilot.com/review/www.toolstation.nl'
</script>
